import React from "react";
import { CustomElement, CustomElementWithAlign } from "./RichTextEditor.types";
import { RenderElementProps } from "slate-react";

const TEXT_ALIGN_TYPES = ["left", "center", "right", "justify"] as const;

type AlignType = (typeof TEXT_ALIGN_TYPES)[number];
export const isAlignElement = (
  element: CustomElement
): element is CustomElementWithAlign => {
  return "align" in element;
};

export const Element: React.FC<RenderElementProps> = ({
  attributes,
  children,
  element,
}) => {
  const style: React.CSSProperties = {};
  if (isAlignElement(element)) {
    style.textAlign = element.align as AlignType;
  }

  switch (element.type) {
    case "block-quote":
      return (
        <blockquote
          style={{
            ...style,
            borderLeft: "2px solid #ddd",
            paddingLeft: "10px",
            margin: "1em 0",
          }}
          {...attributes}
        >
          {children}
        </blockquote>
      );
    case "bulleted-list":
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      );
    case "heading-one":
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      );
    case "heading-two":
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      );
    case "list-item":
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      );
    case "numbered-list":
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      );
      case "link":
        return (
      <a href={element.url} {...attributes}>
        {children}
      </a>
    );  
    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
  }
};
